import styled from 'styled-components';
import { COLOR_WHITE } from 'constants/colors';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLOR_WHITE};
  padding: 1.5rem;
`;
